import _get from 'lodash/get'
import { withLocalization } from 'hocs/localization'

export const withLocalizationErrorMessage = WrappedComponent =>
  withLocalization(({ meta }) => _get(meta, ['error', 0, 'startPath']))(WrappedComponent)
